import { createSlice } from '@reduxjs/toolkit'

export const shiftCollectionSlice = createSlice({
    name: 'shiftCollection',
    initialState: [],
    reducers: {
        setShiftCollections: (state, action) => {
            //console.log('Action', action.payload)
            state = action.payload
            return state
        },
        clearShiftCollections: (state, action) => {
            //console.log('Action', action.payload)
            state = []
            return state
        },
        addComment: (state, action) => {
            console.log('Action', action)
            state = state.push({
                id: action.payload.id,
                comment: action.payload.comment,
                questionId: action.payload.questionId
            })
        },
        editComment: (state, action) => {
            state = state.map(comment => {
                if (comment.id === action.payload.id) {
                    return {
                        id: action.payload.id,
                        comment: action.payload.comment,
                        questionId: action.payload.questionId
                    }
                } else {
                    return {
                        ...comment
                    }
                }
            })
            return state
        },
        removeComment: (state, action) => {
            state = state.filter(comment => comment.id !== action.payload.id)

            return state
        }
    }
})

export const {
    setShiftCollections,
    clearShiftCollections
} = shiftCollectionSlice.actions

//export const comments = (state) => state.comments;
//export const userState = state => state.userState
export const shiftCollections = state => state

export default shiftCollectionSlice.reducer
